export default __webpack_public_path__ + "static/media/video.f8f9b2d3.svg";